export const getTitle = (menu) => {
	return `${menu} | 스타트업 투자 매칭 & 스타트업 성장 관리 플랫폼 | 깃발(gitbal)`;
};
